<template>
  <v-dialog v-model="isVisible" persistent max-width="600px">
    <ivr-test
      @hide="hideTestInputPrompt"
      @send-test-message="_sendTestMessage"
      :is-visible="isTestInputPromptVisible"
    />
    <v-card>
      <v-card-title>
        <span class="headline">
          <span v-if="!(!patients || !patients.length)"> Initiate call </span>
          <span v-if="!patients || !patients.length"> Initiate mass call </span>
        </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <div class="placeHoldersWrapper">
              <div class="label">Select a template to use:</div>
              <v-select
                v-model="selectedTemplateId"
                class="filterSelector"
                :items="selectableTemplates"
                label="Select Template"
                item-text="name"
                item-value="templateID"
              />
            </div>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="field.content"
                label="Content *"
                required
                counter
                full-width
                single-line
                :disabled="isContentDisabled"
              />
            </v-col>
          </v-row>
        </v-container>

        <small>* indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary"
          text
          @click="showTestInputPrompt"
          :disabled="!field.content.length"
        >
          Test
        </v-btn>
        <v-btn color="secondary" text @click="close"> Cancel </v-btn>
        <v-btn
          color="primary"
          text
          @click="send"
          :disabled="!field.content.length || selectedTemplateId === -1"
        >
          Initiate Call
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-snackbar v-model="snackbar">
      {{ notification }}

      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
  /* eslint-disable */
import { ApiCalls } from "../../../../api-calls";
import HelperMethods from "../../../../utils/helper-methods";
// import UserHelper from "../../../../utils/user-helper";
import Api from "../../../shared-module/api";

export default {
  name: "IvrCallInitiator",
  components: {
    IvrTest: () => import("../ivr-test/ivr-test.vue"),
  },
  props: {
    patients: {
      type: Array,
      default: null,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dialog: false,
    field: {
      content: "",
    },
    practiceID: "",
    maxMessageLength: 200,
    snackbar: false,
    notification: "Unknown",
    selectedTemplate: null,
    selectedTemplateId: -1,
    isTestInputPromptVisible: false,
    // emailTemplates: [],
    isContentDisabled: false,
    templates: [],
    selectedTemplateType: "userTemplates",
    selectableTemplates: [],
  }),

  watch: {
    templates(val) {
      if (val && val.length) {
        this.emailTemplates = val.filter((t) => t.templateTypeID === 3);
      }
    },
    '$store.state.posActivePractice': function () {
      this._loadMetadata();
    },
    isVisible(val) {
      if (val) {
        this._fetchTemplates();
      }
    },
    selectedTemplateId(val) {
      this.isContentDisabled = false;
      this.selectedTemplate = null;
      this.field.content = "";
      if (val > 0) {
        const template = this.selectableTemplates.find((t) => t.templateID === val);
        if (template) {
          this.selectedTemplate = template;
          this.field.content = template.templateBody ? template.templateBody : "";
          this.isContentDisabled = this._determineContentDisability(template);
        }
      }
    },
    selectedTemplateType(val) {
      this._onTemplateTypeUpdate(val);
    },
  },

  created() {
    this._loadMetadata();
  },

  methods: {
    async _loadMetadata() {
      // const activeClinic = UserHelper.getActiveClinic();
      // const practiceId = activeClinic.PracticeID;
      if (this.$store.state.posActivePractice.value) {
        try {
          const response = await Api.template.private.fetchPracticeTemplates({
            templateCategoryId: 3,
            practiceId: this.$store.state.posActivePractice.value
          });
          this.selectableTemplates = response.data.filter((t) => t.templateTypeID === 3);
        } catch (error) {
          console.log("error :>> ", error);
          // setTimeout(() => {
          //   this.isPromptVisible = false;
          // }, 1000);
        }
      }
    },
    _generateIvrTemplates(templates = []) {
      return templates.filter(
        (template) => template.templateCategoryID !== 2 && template.templateCategoryID !== 1
      );
    },
    _selectTemplateType(templateType) {
      this.selectedTemplateType = templateType;
    },
    _onTemplateTypeUpdate(val) {
      this.selectedTemplateId = null;
      this.selectedTemplate = null;
      this.isContentDisabled = false;
      this.selectedTemplate = null;
      this.selectedTemplateMediaUrl = "";
      this.field.message = "";
      if (val === "userTemplates") {
        this.selectableTemplates = this.templates.filter((t) => t.templateType === "user");
      } else {
        // System templates
        this.selectableTemplates = this.templates.filter((t) => t.templateType === "system");
      }
    },
    _determineContentDisability(selectedTemplate) {
      if (
        selectedTemplate &&
        selectedTemplate.templateCategoryID &&
        selectedTemplate.templateCategoryID === 3
      ) {
        return false;
      }
      return true;
    },

    async _fetchTemplates() {
      try {
        const response = await ApiCalls.fetchIvrTemplates();
        this.templates = response.data;
      } catch (error) {
        this.templates = [];
      }
    },

    async send() {
      // if (!Array.isArray(this.patients) && !this.patients.length) {
      //   return;
      // }

      if (!this.selectedTemplate) {
        this.notification = "Please select a template";
        this.snackbar = true;
        return;
      }

      if (!this.field.content.length && !this.file) {
        // this.notification = "Please add a message or select a file to send";
        this.notification = "Please add a content";
        this.snackbar = true;
        return;
      }

      if (!HelperMethods.validateMessagePlaceholders(this.field.content)) {
        this.snackbar = true;
        this.notification = 'First name and Last name in the same message violates HIPAA laws';
        return;
      }

      if (this.patients && this.patients.length) {
        const phoneNumbers = [];
        this.patients.forEach((patient) => {
          const phoneNumber = this._prependAreaCodeIfRequired(patient.phone);
          if (phoneNumber) {
            phoneNumbers.push(phoneNumber);
          }
        });
        const messagePayload = {
          FlowID: this.selectedTemplate.flowID,
          ToPhoneNumbers: phoneNumbers.join(";"),
          FlowPhoneNumber: "+17088872527",
          Message: this.field.content,
          MessageCategoryTypeID: 3 // No group selected
        };
        try {
          await Api.ivr.private.initiateCall(messagePayload);
          this.notification = "Test call successfully initiated";
          this.snackbar = true;
          this.$emit("on-success");
          this.close();
        } catch (error) {
          this.notification = "Unable to initiate call";
          this.snackbar = true;
          this.$emit("on-error", error);
        }
      }
    },

    _prependAreaCodeIfRequired(phoneNumber) {
      if (phoneNumber && phoneNumber.length) {
        if (phoneNumber.indexOf("+1") === 0) {
          return phoneNumber;
        } else {
          return `+1${phoneNumber}`;
        }
      }
      return null;
    },

    async _sendTestMessage(testPhone) {
      this.isTestInputPromptVisible = false;
      this.displayMode = "loader";
      const messagePayload = {
        FlowID: this.selectedTemplate.flowID,
        ToPhoneNumbers: `${this._prependAreaCodeIfRequired(testPhone)};`,
        FlowPhoneNumber: "+17088872527",
        Message: this.field.content,
        MessageCategoryTypeID: 3
      };
      // if (this.selectedTemplate) {
      //   messagePayload.MessageCategoryTypeID = this.selectedTemplate.templateCategoryID;
      // } else {
      //   messagePayload.MessageCategoryTypeID = 3;
      // }
      try {
        await Api.ivr.private.initiateCall(messagePayload);
        this.notification = "Test call successfully initiated";
        this.snackbar = true;
      } catch (error) {
        this.notification = "Unable to initiate call";
        this.snackbar = true;
      }
      this.displayMode = "form";
    },

    showTestInputPrompt() {
      if (!Array.isArray(this.patients) && !this.patients.length) {
        return;
      }

      if (!this.field.content.length && !this.file) {
        // this.notification = "Please add a message or select a file to send";
        this.notification = "Please select a template";
        this.snackbar = true;
        return;
      }

      if (!HelperMethods.validateMessagePlaceholders(this.field.content)) {
        this.snackbar = true;
        this.notification = 'First name and Last name in the same message violates HIPAA laws';
        return;
      }
      this.isTestInputPromptVisible = true;
    },

    hideTestInputPrompt() {
      this.isTestInputPromptVisible = false;
    },

    close() {
      this.$emit("dismiss");
      this.file = null;
      this.field = Object.assign({
        content: "",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.placeHoldersWrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 15px 15px;
  margin-top: 25px;
  margin-bottom: 15px;
  border: 1px solid rgb(58, 58, 58);
  border-radius: 8px;
  position: relative;
  padding-top: 42px;
  .templateTypeSelectorOuterWrapper {
    position: absolute;
    top: 15px;
    right: 15px;
    .templateTypeSelectorInnerWrapper {
      display: flex;
      border: 1px solid #3dbc83;
      border-radius: 60px;
      padding: 4px 4px;
      background: #3dbc83;
      transition: 0.3s !important;
      &:hover {
        background: #21ad6e;
      }
      .tab {
        padding: 2px 8px;
        border-radius: 60px;
        font-size: 8px;
        color: white;
        font-weight: 600;
        cursor: pointer;
        &.selected {
          color: white;
          // padding: 2px 12px;
          font-size: 10px;
          box-shadow: 6px 6px 8px rgba(0, 0, 0, 0.2);
          background: #020202;
          font-weight: 600;
        }
      }
    }
  }
}
.label {
  color: rgb(17, 17, 17);
  font-weight: 600;
  margin-right: 15px;
  width: 150px;
}

.dropdown {
  display: inline-block;
  position: relative;
}

.dd-button {
  display: inline-block;
  border: 1px solid gray;
  border-radius: 4px;
  padding: 4px 80px 4px 60px;
  background-color: #ffffff;
  cursor: pointer;
  font-size: 1rem;
  white-space: nowrap;
}

.dd-button:after {
  content: "";
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid black;
}

.dd-button:hover {
  background-color: #eeeeee;
}

.dd-input {
  display: none;
}

.dd-menu {
  position: absolute;
  top: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0;
  margin: 0 0 0 0;
  z-index: 5555555;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  list-style-type: none;
}

.dd-input + .dd-menu {
  display: none;
}

.dd-input:hover + .dd-menu {
  display: block;
}

.dd-menu li {
  width: 180px;
  padding: 0px 20px;
  cursor: pointer;
  white-space: nowrap;
}

.dd-menu li:hover {
  background-color: #f6f6f6;
}

.dd-menu li a {
  display: block;
  margin: -10px -20px;
  padding: 10px 20px;
}

.dd-menu li.divider {
  padding: 0;
  border-bottom: 1px solid #cccccc;
}
.toggleWrapper {
  display: flex;
  align-items: center;
  span {
    font-size: 1.1rem;
    margin-left: 1rem;
  }
  input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
  }
  input[type="checkbox"]:focus {
    outline: 0;
  }

  .toggle {
    height: 16px;
    width: 42px;
    border-radius: 16px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: 2px solid grey;
    background: grey;
    transition: all 0.2s ease;
  }
  .toggle:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 4px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: white;
    box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
    transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
  }
  .toggle:checked {
    border-color: rgb(0, 182, 91);
    background: rgb(0, 185, 108);
  }
  .toggle:checked:after {
    transform: translatex(20px);
  }
}
</style>
<style lang="scss">
.vdatetime-input {
  border-bottom: 2px solid black;
}
.fileWrapper {
  margin: 15px 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 7px 25px;
  border: 1px solid rgb(0, 182, 91);
  border-radius: 4px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.15);
  .filePart {
    flex: 7;
    display: flex;
    align-items: center;
    .iconWrapper {
      margin-right: 12px;
      color: rgb(0, 182, 91);
      * {
        color: rgb(0, 182, 91);
      }
    }
    .nameWrapper {
      margin-top: 3px;
      font-size: 0.9rem;
      font-weight: 400;
      line-height: 18px;
      .fileSize {
        font-size: 0.7rem;
        font-weight: 600;
      }
    }
  }
  .actionPart {
    flex: 3;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .changeBtn {
      background-color: rgb(56, 179, 255);
      padding: 0px 15px;
      cursor: pointer;
      font-weight: 600;
      color: white;
      * {
        font-size: 1.3rem;
        color: white;
        margin-top: -4px;
      }
      border-radius: 50px;
      font-size: 0.8rem;
    }
    .removeBtn {
      cursor: pointer;
      * {
        color: rgb(251, 59, 59);
      }
    }
  }
}
.uploadBtn {
  margin: 15px 0;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 7px 25px;
  justify-content: center;
  cursor: pointer;
  border: 1px solid rgb(0, 182, 91);
  border-radius: 4px;
  box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.15);
  .iconWrapper {
    margin-right: 12px;
    color: rgb(0, 182, 91);
    * {
      color: rgb(0, 182, 91);
    }
  }
  .labelWrapper {
    color: rgb(0, 182, 91);
    margin-top: 3px;
    font-size: 0.9rem;
    font-weight: 400;
  }
  &:hover {
    box-shadow: 4px 4px 12px rgba(0, 0, 0, 0.088);
  }
}
.vue__time-picker.time-picker {
  border: none !important;
  border-bottom: 2px solid black !important;
  width: 12.5em !important;
  input {
    height: 1.6em !important;
    border: none !important;
    outline: none !important;
  }
}
</style>
